"use client";

import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Consultation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.1
  });
  return <section data-section-id="4170" id="richiedi-una-consulenza-gratuita" className="bg-background text-foreground relative overflow-hidden py-20 md:py-28 lg:py-32 px-4 sm:px-6 lg:px-10">
      <div ref={ref} className={`max-w-2xl mx-auto text-center transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl text-foreground font-normal tracking-tight mb-6">
          Contatti
        </h2>

        <p className="font-sans text-base sm:text-lg text-muted-foreground leading-relaxed mb-10">
          WhatsApp +39 389 286 6221 (solo messaggi WhatsApp). Orari: lunedì–venerdì 09:00–18:00, sabato 09:00–14:00, domenica chiuso.
        </p>

        <div className="flex justify-center">
          <Button asChild size="lg" className="h-14 px-8 font-sans text-base font-semibold tracking-wide rounded-lg shadow-md">
            <Link to="https://wa.me/393892866221" newTab className="inline-flex items-center gap-2">
              <MessageCircle className="size-5" />
              Scrivici su WhatsApp
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}